<template>
  <div class="list row">
    <div class="row toolbar">
      <div :class="superUser ? 'col-12 col-lg-4' : 'col-12 col-lg-6 col-xl-5'">
        <h4 v-if="superUser" class="page-title col-xs-12 col-sm-4">
          {{ $t('common.issue') }}
        </h4>
        <h4 v-else class="page-title col-xs-12 col-sm-4">
          {{ $t('issue.my_issue') }}
        </h4>
        <div class="search-wrapper col-12 col-sm-8 float-sm-right">
          <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="7" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input v-model="searchIssue" type="text" class="search-input" :placeholder="$t('common.quick_search')">
        </div>
      </div>
      <div class="row" :class="superUser ? 'col-12 col-lg-8' : 'col-12 col-lg-6 col-xl-7'">
        <div class="col-12 col-sm-6 col-xl-5">
          <div class="input-group input-group-sm mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text">  Ordenar Por </span>
            </div>
            <select v-model="sorting" class="custom-select">
              <option value="id:asc">
                Id Ascendente
              </option>
              <option value="id:des">
                Id Descendente
              </option>
              <option v-if="!customerUser" value="customer:asc">
                Cliente
              </option>
              <option v-if="!customerUser" value="priority:des">
                Prioridad
              </option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <button v-if="!customerUser" class="btn btn-info btn-vuvle mr-1" data-toggle="modal" data-target="#filters">
            {{ $t('action.filter') }}
          </button>
          <button class="btn btn-warning btn-vuvle" @click="togglePerformantIssues()">
            {{perfIssueStatus}}
          </button>
        </div>
      </div>
      <!-- <pagination v-show="inPagination" class="col-sm-12" :total="total" :page.sync="listQuery.page" :size.sync="listQuery.size" @pagination="getPaginatedList" /> -->
    </div>
    <div class="row issues-wrapper">
      <div class="col-lg-4">
        <ul class="ticketlist">
          <li v-for="(anIssue, index) in filteredIssues" :key="index" :class="setClass(anIssue)" @click="selectIssue(anIssue)">
            <div class="ticket-wrapper">
              <div class="ticket-head">
                <span class="ticket-id">#{{ getTicketId(anIssue) }}</span>
                <span class="ticket-date">{{ formatDate(anIssue.dateCreated) }}</span>
              </div>
              <div class="ticket-customer">
                {{anIssue.customer.firstName}}
              </div>
              <div class="ticket-meta">
                <font-awesome-icon icon="phone-alt" /> {{anIssue.customer.phone}}
                <span v-if="anIssue.deviceBrand"> · <span v-if="anIssue.deviceBrand.length >= 30">{{anIssue.deviceBrand.substring(0, 29) + '...'}}</span><span v-else>{{anIssue.deviceBrand}}</span></span>
              </div>
              <div class="ticket-footer">
                <span :class="'badge badge-' + statusClass(anIssue)">{{translateStatus(anIssue)}}</span>
                <span v-if="!anIssue.assignedTo && !customerUser" class="badge badge-pill badge-danger">{{ $t('issue.none_assigned_to') }}</span>
                <span v-else-if="!customerUser" class="badge badge-pill badge-info">{{anIssue.assignedTo.username}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="issue-container col-lg-8">
        <issue ref="issueComponent" :issue="selectedIssue" :technicians="technicians" :is-customer="customerUser" :super-user="superUser" @refreshData="refreshList" @updateTicket="updateIssue" />
      </div>
    </div>
    <!-- Filters modal -->
    <div v-if="!customerUser" id="filters" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">
              {{ $t('action.filter') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('action.only_active') }}</span>
              </div>
              <div class="form-control">
                <input v-model="onlyActive" type="checkbox" @click="toggleIssues">
                <span class="d-none d-md-inline" style="font-size:14px;float:right;"> ← </span>
              </div>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> {{ $t('issue.status') }} </span>
              </div>
              <select v-model="statusFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option :value="null">
                  Nuevo
                </option>
                <option v-for="(stObj, name) in status" :key="name" :value="stObj.id">
                  {{stObj.name}}
                </option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <!-- <span class="input-group-text">  {{ $t('issue.priority') }} </span> -->
                <span class="input-group-text"> Sucursal </span>
              </div>
              <select v-model="priorityFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option value="">
                  <!-- Ninguna -->
                  Nueva Palmira
                </option>
                <option v-for="(stObj, name) in priorities" :key="name" :value="stObj.id">
                  {{stObj.name}}
                </option>
              </select>
            </div>
            <div v-if="superUser">
              <div class="input-group input-group-sm mb-1">
                <div class="input-group-prepend">
                  <span class="input-group-text"> {{ $t('sidebar.employees') }} </span>
                </div>
                <select v-model="techFiltered" class="custom-select">
                  <option value="all">
                    {{ $t('common.all') }}
                  </option>
                  <option v-for="(tech, name) in technicians" :key="name" :value="tech.username">
                    {{ tech.username | capitalize }}
                  </option>
                </select>
              </div>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> {{ $t('common.short_type') }} </span>
              </div>
              <select v-model="typeFiltered" class="custom-select">
                <option value="all">
                  {{ $t('common.all') }}
                </option>
                <option value="">
                  Smartdrone
                </option>
                <option value="Presupuesto">
                  Presupuesto
                </option>
                <option value="Sancor">
                  Sancor
                </option>
                <option value="Daferol">
                  Daferol
                </option>
                <option value="Termalesuy">
                  Termalesuy
                </option>
                <option value="AMV">
                  AMV
                </option>
                <option value="Zerisur">
                  Zerisur
                </option>
                <option value="PcService">
                  PcService
                </option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text"> Desde </span>
              </div>
              <input v-model="dateFiltered.from" type="date" class="form-control" placeholder="desde">
              <div class="input-group-prepend">
                <span class="input-group-text"> Hasta </span>
              </div>
              <input v-model="dateFiltered.to" type="date" class="form-control" placeholder="hasta">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="removeFilters">
              {{ $t('action.remove_filter') }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              {{ $t('action.ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
// import StatusService from '@/services/status.service';
import PriorityService from '@/services/priority.service';
import Issue from '@/views/issues/Issue';
// import UserService from '@/services/user.service';
import { getTicketId, formatDate } from '@/utils/page-utils';
// import { EventBus } from '@/utils/event.bus.js';
// import Pagination from '@/components/Pagination';

export default {
    name: 'IssueList',
    components: {
        Issue
    // , Pagination
    },
    filters: {
        capitalize: function capitalize(value) {
            var processVal = value;
            if (!processVal) {
                return '';
            }
            processVal = processVal.toString();
            return processVal.charAt(0).toUpperCase() + processVal.slice(1);
        }
    },
    props: {
        issue: Object
    },
    data() {
        return {
            perfIssueStatus: '6 meses',
            searchIssue: '',
            sorting: 'id:asc',
            statusFiltered: 'all',
            techFiltered: 'all',
            typeFiltered: 'all',
            priorityFiltered: 'all',
            dateFiltered: {},
            priorities: null,
            selectedIssue: {},
            // technicians: [],
            onlyActive: true,
            // pagination related properties
            listQuery: {
                page: this.$store.state.issues.issues.number + 1,
                size: 20
            }
        };
    },
    computed: {
        inPagination: {
            // getter
            get: function get() {
                return this.$store.state.issues.inpagination;
            },
            // setter
            set: function set(newValue) {
                this.$store.dispatch('issues/setPaginated', newValue);
                if (this.onlyActive && newValue) {
                    this.onlyActive = false;
                } else if (!this.onlyActive && !newValue) {
                    this.onlyActive = true;
                }

                this.refreshList();
            }
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        superUser() {
            return this.currentUser && (this.currentUser.roles.includes('ROLE_ADMIN') || this.currentUser.roles.includes('ROLE_MODERATOR'));
        },
        customerUser() {
            return !this.superUser && this.currentUser && !this.currentUser.roles.includes('ROLE_TECHNICIAN') && this.currentUser.roles.includes('ROLE_CUSTOMER');
        },
        technicians() {
            return this.$store.state.technicians.technicians;
        },
        status() {
            return this.$store.state.issues.status;
        },
        issues() {
            if (this.inPagination) {
                return this.$store.state.issues.issues.content;
            }
            return this.$store.state.issues.issues;
        },
        filteredIssues() {
            let retFilteredIssues;

            if (this.searchIssue || this.statusFiltered !== 'all' || this.techFiltered !== 'all' || this.typeFiltered !== 'all' ||
                this.priorityFiltered !== 'all' || this.dateFiltered.from
            ) {
                if (this.searchIssue) {
                    if (isNaN(this.searchIssue)) {
                        if (this.searchIssue.toLowerCase().includes('sku:')) {
                            const sku = this.searchIssue.toLowerCase().split('sku:')[1];
                            retFilteredIssues = this.issues.filter(issue => {
                                return issue.sku && issue.sku.toLowerCase().includes(sku);
                            });
                        } else {
                            retFilteredIssues = this.issues.filter(issue => {
                                return issue.deviceBrand && issue.deviceBrand.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                    issue.customer.firstName.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                    issue.serialNo && issue.serialNo.toLowerCase().includes(this.searchIssue.toLowerCase());
                            });
                        }
                    } else {
                        retFilteredIssues = this.issues.filter(issue => {
                            return issue.customer.phone.toLowerCase().includes(this.searchIssue.toLowerCase()) ||
                                issue.serialNo && issue.serialNo.toLowerCase().includes(this.searchIssue.toLowerCase());
                        });
                    }
                }

                if (!retFilteredIssues) {
                    retFilteredIssues = this.issues;
                }

                if (this.statusFiltered !== 'all') {

                    if (!this.statusFiltered) {
                        retFilteredIssues = retFilteredIssues.filter(issue => {
                            return !issue.status2;
                        });
                    } else {
                        retFilteredIssues = retFilteredIssues.filter(issue => {
                            return issue.status2 && issue.status2.id === this.statusFiltered;
                        });
                    }
                }

                if (this.priorityFiltered !== 'all') {
                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        if (this.priorityFiltered === '') {
                            return !issue.priority;
                        }
                        return issue.priority && issue.priority.id === this.priorityFiltered;
                    });
                }

                if (this.techFiltered !== 'all') {

                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        return issue.assignedTo && issue.assignedTo.username.toLowerCase() === this.techFiltered.toLowerCase();
                    });
                }

                if (this.typeFiltered !== 'all') {

                    retFilteredIssues = retFilteredIssues.filter(issue => {
                        if (this.typeFiltered === '') {
                            return !issue.issueType || issue.issueType.toLowerCase() === '';
                        }
                        return issue.issueType && issue.issueType.toLowerCase() === this.typeFiltered.toLowerCase();
                    });
                }
                retFilteredIssues = this.filterDate(retFilteredIssues);

                return this.sortResults(retFilteredIssues);
            }
            return this.sortResults(this.issues);
        },
        total() {
            if (this.$store.state.issues.loading) {
                return 0;
            }
            if (this.inPagination) {
                return this.$store.state.issues.issues.totalElements;
            }
            return this.$store.state.issues.issues.length;
        }
    },
    created() {
        var self = this;
        // EventBus.$on('internalSearch', issueSelected => {
        //     // no coexisten las posibilidades de cargar desde paginas y buscar algo a la vez.
        //     var interval, i;
        //     this.$store.dispatch('issues/setPaginated', false);
        //     this.onlyActive = false;
        //     // this.refreshList();
        //     this.$store.dispatch('issues/getIssues');
        //     i = 0;
        //     interval = setInterval(function tryToSelect() {
        //         if (!self.$store.state.issues.loading) {
        //             self.selectIssue(issueSelected);
        //             clearInterval(interval);
        //         } else if (i > 1000) {
        //             clearInterval(interval);
        //             console.error('Limpiamos intervalo, algo malo está sucediendo...');
        //         }
        //         i++;
        //     }, 1);
        // });

        if (this.issue) {
            setTimeout(function waitATick() {
                self.selectIssue(self.issue);
            }, 1);
        }

        // When issues come from a search, it wont have a relation with the list.
        this.refreshList();
    },
    methods: {
    /* eslint-disable no-console */
        filterDate(issues) {
            let fromDate, toDate, tempDate;
            let filteredResult = issues;

            if (this.dateFiltered.from || this.dateFiltered.to) {
                if (!this.dateFiltered.from) {
                    this.dateFiltered.from = new Date().toISOString().substr(0, 10);
                }
                if (!this.dateFiltered.to) {
                    this.dateFiltered.to = new Date().toISOString().substr(0, 10);
                }

                fromDate = new Date(this.dateFiltered.from).getTime();
                toDate = new Date(this.dateFiltered.to).getTime();

                if (fromDate > toDate) {
                    tempDate = this.dateFiltered.to;
                    this.dateFiltered.to = this.dateFiltered.from;
                    this.dateFiltered.from = tempDate;

                    fromDate = new Date(this.dateFiltered.from).getTime();
                    toDate = new Date(this.dateFiltered.to).getTime();
                }

                filteredResult = filteredResult.filter(issue => {
                    const issueDate = new Date(issue.dateCreated.split('T')[0]).getTime();

                    return issueDate && fromDate <= issueDate && toDate >= issueDate;
                });
            }
            return filteredResult;
        },
        sortResults(issues) {
            let sortedResults = issues;
            if (this.sorting === 'id:asc') {
                sortedResults.sort((a, b) => a.id - b.id);
            } else
            if (this.sorting === 'id:des') {
                sortedResults.sort((a, b) => b.id - a.id);
            } else if (this.sorting === 'customer:asc') {
                sortedResults.sort((a, b) => {
                    const customerNameA = a.customer.firstName.toUpperCase();
                    const customerNameB = b.customer.firstName.toUpperCase();
                    if (customerNameA < customerNameB) {
                        return -1;
                    } else
                    if (customerNameA > customerNameB) {
                        return 1;
                    }

                    return 0;
                });
            } else if (this.sorting === 'priority:des') {
                sortedResults.sort((a, b) => {
                    const priorityA = a.priority;
                    const priorityB = b.priority;

                    if (priorityA && priorityB) {
                        return priorityA.sequence - priorityB.sequence;
                    } else if (priorityB) {
                        return 1;
                    } else if (priorityA) {
                        return -1;
                    }
                    return 0;
                });
            }
            return sortedResults;
        },
        selectIssue(issue) {
            var self = this;
            if (this.issues) {
                // cleaning because of duplicates.
                this.issues.forEach(anIssue => {
                    delete anIssue.class;
                });
            }
            this.selectedIssue = this.issues.filter(askIssue => askIssue.id === issue.id)[0];

            if (this.selectedIssue) {
                IssueService.getData(this.selectedIssue.id).then(
                    response => {
                        this.selectedIssue = response.data;
                        this.$refs.issueComponent.initIssueComponent(this.selectedIssue);
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );

                // this.$refs.issueComponent.initIssueComponent();
                this.selectedIssue.class = 'selected';
            }
        },
        translateStatus(issue) {
            var active = issue.active;
            var status = issue.status;
            var status2 = issue.status2;
            if (!active) {
                return 'Cerrado';
            }
            if (!status2) {
                return 'Nuevo';
            }
            return status2.name;
        },
        statusClass(issue) {
            var retVal = 'primary';
            var triggersStr, triggerActions;
            if (issue.status2 && issue.status2.triggers) {
                triggersStr = '{' + issue.status2.triggers + '}';
                try {
                    triggerActions = JSON.parse(triggersStr);

                    if (triggerActions.className) {
                        retVal = triggerActions.className;
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            if (!issue.active) {
                return 'dark';
            }
            if (retVal === 'primary') {
                // if primary still there, means that status2 is not giving any classname.
                if (issue.status === 'WaitingForCustomer' || issue.status === 'NotRepaired') {
                    retVal = 'warning';
                } else if (issue.status === 'Repaired') {
                    retVal = 'success';
                }
            }
            return retVal;
        },
        setClass(issue) {
            var retVal = '';
            var triggersStr, triggerActions;

            if (issue.class) {
                retVal = issue.class + ' ';
            }

            if (!issue.active) {
                return retVal + 'dark';
            } else
            if (!issue.assignedTo) {
                retVal += 'danger';
            }

            if (issue.priority) {
                // as we are running through all the issues here, we could check those with technical alerts.
                // if (issue.priority.type === 'ALERT' && this.currentUser.roles.includes('ROLE_ADMIN') && !issue.triggered &&
                //     (!issue.class || issue.class && issue.class.includes('selected'))
                // ) {
                //     if (!issue.toast) {
                //         issue.toast = true;
                //     } else {
                //         if (issue.class && issue.class.includes('selected')) {
                //             issue.triggered = true;
                //         }
                //         issue.toast = false;
                //     }
                // }

                if (issue.priority.triggers) {
                    triggersStr = '{' + issue.priority.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        if (triggerActions.className) {
                            retVal += ' tag-' + triggerActions.className + ' ';
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }

            if (issue.status2) {
                if (issue.status2.triggers) {

                    triggersStr = '{' + issue.status2.triggers + '}';
                    try {
                        triggerActions = JSON.parse(triggersStr);

                        if (triggerActions.className) {
                            retVal += triggerActions.className;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    retVal += 'primary';
                }
            } else
            if (issue.status === 'WaitingForCustomer' || issue.status === 'NotRepaired') {
                retVal += 'warning';
            } else
            if (issue.status === 'Repaired') {
                retVal += 'success';
            }

            if (retVal === '' || issue.class && retVal === issue.class + ' ') {
                retVal += 'primary';
            }

            return retVal;
        },
        getTicketId,
        formatDate,
        getPaginatedList() {
            this.refreshList();
        },
        removeFilters() {
            this.statusFiltered = 'all';
            this.techFiltered = 'all';
            this.typeFiltered = 'all';
            this.priorityFiltered = 'all';
            this.dateFiltered = {};
        },
        refreshList(forceOnlyActive) {
            const forceOnlyActiveRequest = forceOnlyActive === 'forceOnlyActive';
            // get Statuses if null.
            // if (!this.status) {
            //     StatusService.getStatus(true).then(
            //         response => {
            //             this.status = response.data;
            //         },
            //         error => {
            //             console.log(error.response && error.response.data ||
            //           error.message || error.toString());
            //         }
            //     );
            // }
            // get Priorities if null. Not needed now.
            if (!this.priorities) {
                PriorityService.getPriorities(true).then(
                    response => {
                        this.priorities = response.data;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                      error.message || error.toString());
                    }
                );
            }
            if (!this.$store.state.issues.status || !this.$store.state.issues.status.length) {
                this.$store.dispatch('issues/getStatus');
            }
            if (!this.$store.state.technicians.technicians || !this.$store.state.technicians.technicians.length) {
                this.$store.dispatch('technicians/getTechnicians');
            }
            // this.$store.dispatch('issues/getIssueFields');

            if (this.superUser && this.inPagination) {
                this.$store.dispatch('issues/getPaginatedIssues', this.listQuery);
            } else if (this.customerUser) {
                // customer Behaviour.
                this.$store.dispatch('issues/getCustomerIssues', this.currentUser.email);
            } else if (!this.$store.state.issues.issues.length || forceOnlyActiveRequest) {
                this.$store.dispatch('issues/getPerformantIssues');
            }
        },
        toggleIssues() {
            // technical staff has access to other places.
            if (!this.superUser) {
                if (this.customerUser) {
                    this.$store.dispatch('issues/getCustomerIssues', this.currentUser.email);
                } else
                if (this.onlyActive) {
                    this.$store.dispatch('issues/getIssues');
                } else {
                    this.$store.dispatch('issues/getPerformantIssues');
                }
                return;
            }
            // super users can check many things
            if (!this.onlyActive) {
                this.$store.dispatch('issues/setPaginated', false);
                this.refreshList('forceOnlyActive');
            } else {
                this.$store.dispatch('issues/getIssues');
            }
        },
        togglePerformantIssues() {
            if (this.perfIssueStatus === '6 meses') {
                this.perfIssueStatus = 'Mostrando sin limite';
                this.$store.dispatch('issues/getActiveIssues');
            } else {
                this.perfIssueStatus = '6 meses';
                this.$store.dispatch('issues/getPerformantIssues');
            }
        },
        updateIssue(issue) {
            if (issue.id === this.selectedIssue.id) {
                this.selectedIssue = issue;
            }
            this.$store.dispatch('issues/updateIssue', issue);
        }
    /* eslint-enable no-console */
    }
};
</script>

<style lang="scss">
@import "../../styles/theme.scss";

// Local aliases so the status/priority classnames coming from the backend
// (danger/warning/success/primary/secondary/info) keep working unchanged.
$danger: $issue-danger;
$warning: $issue-warning;
$success: $issue-success;
$primary: $issue-primary;
$secondary: $issue-secondary;
$info: $issue-info;

.row.list {
  text-align: left;
  margin-left: 0;
  margin-right: 0;
  padding: 20px 24px 28px;
  background-color: $issue-bg-page;
  min-height: calc(100vh - 50px);
  > .row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}

// Toolbar (title, search, sort & filter actions)
.toolbar {
  align-items: center;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid $issue-border;

  .page-title {
    display: inline-block;
    margin: 0 0 8px;
    font-weight: 700;
    font-size: 20px;
    color: $issue-text;
    letter-spacing: -0.01em;
  }

  .custom-select,
  .input-group-text {
    border-color: $issue-border;
    font-size: 12px;
  }

  .custom-select {
    border-radius: 0 $issue-radius-sm $issue-radius-sm 0;
    color: $issue-text;
    &:focus {
      border-color: $issue-primary;
      box-shadow: 0 0 0 3px $issue-primary-soft;
    }
  }

  .input-group-text {
    background-color: $issue-bg-subtle;
    color: $issue-text-muted;
    border-radius: $issue-radius-sm 0 0 $issue-radius-sm;
  }

  .btn-vuvle {
    border-radius: $issue-radius-sm;
    font-weight: 600;
    font-size: 12px;
    box-shadow: $issue-shadow-sm;
    transition: transform .12s ease, box-shadow .12s ease;
    &:hover {
      transform: translateY(-1px);
      box-shadow: $issue-shadow;
    }
    &:active {
      transform: translateY(0);
    }
  }
}

.issues-wrapper {
  align-items: flex-start;
}

.ticketlist > li {
    font-size: 13px;
    background-color: #fff;
    border: 1px solid $issue-border;
    border-left: 4px solid $issue-border;
    border-radius: $issue-radius-sm;
    overflow: hidden;
    margin-bottom: 8px;
    padding: 10px 12px;
    position: relative;
    cursor: pointer;
    box-shadow: $issue-shadow-sm;
    transition: box-shadow .15s ease, border-color .15s ease, transform .15s ease;

    &:hover {
        box-shadow: $issue-shadow-hover;
        transform: translateY(-1px);
    }

    .ticket-wrapper {
        width: 100%;
    }
    .ticket-head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        color: $issue-text-muted;
        font-size: 11px;
        margin-bottom: 2px;
    }
    .ticket-id {
        font-weight: 700;
        color: $issue-text;
    }
    .ticket-customer {
        font-weight: 600;
        color: $issue-text;
        font-size: 14px;
        margin-bottom: 2px;
    }
    .ticket-meta {
        color: $issue-text-muted;
        font-size: 12px;
        margin-bottom: 8px;
        svg {
            margin-right: 2px;
        }
    }
    .ticket-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 4px;
    }

    &.dark { border-left-color: $issue-dark; }
    &.danger { border-left-color: $danger; }
    &.warning { border-left-color: $warning; }
    &.success { border-left-color: $success; }
    &.primary { border-left-color: $primary; }
    &.secondary { border-left-color: $secondary; }
    &.info { border-left-color: $info; }

    &.selected {
        background-color: $issue-primary-soft;
        border-color: rgba($issue-primary, 0.35);
        border-left-width: 4px;
        box-shadow: $issue-shadow-hover;
    }

    // Priority tags
    &.tag {
        &-danger { background-color: $issue-danger-soft; }
        &-warning { background-color: $issue-warning-soft; }
        &-success { background-color: $issue-success-soft; }
        &-primary { background-color: $issue-primary-soft; }
        &-secondary { background-color: $issue-secondary-soft; }
        &-info { background-color: $issue-info-soft; }
    }
}

.selected {
     border: 1px solid $issue-primary;
}

.ticketlist {
    padding-left: 0;
    list-style: none;
    max-height: 85vh;
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 3px;
    }
}

// Badges: soft, pill-shaped status indicators.
.list .badge {
    font-weight: 600;
    font-size: 10.5px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    padding: 4px 9px;
    border-radius: 999px;
}
.list .badge-primary { color: $primary; background-color: rgba($primary, 0.12); }
.list .badge-secondary { color: $secondary; background-color: rgba($secondary, 0.12); }
.list .badge-success { color: darken($success, 8%); background-color: rgba($success, 0.14); }
.list .badge-danger { color: darken($danger, 4%); background-color: rgba($danger, 0.12); }
.list .badge-warning { color: darken($warning, 12%); background-color: rgba($warning, 0.2); }
.list .badge-info { color: $info; background-color: rgba($info, 0.12); }
.list .badge-dark { color: #fff; background-color: $issue-dark; }

.badge-pill.badge-danger {
    margin-left: 0;
}

.search-wrapper {
  position: relative;
  padding-right: 5px;
  display: flex;
  align-items: center;

  .search-icon {
    position: absolute;
    right: 13px;
    top: 50%;
    width: 15px;
    height: 15px;
    transform: translateY(-50%);
    color: $issue-text-muted;
    pointer-events: none;
    z-index: 1;
  }

  .search-input {
      box-shadow: $issue-shadow-sm;
      font-size: 13px;
      line-height: 1.4;
      width: 100%;
      padding: 8px 37px 8px 14px;
      border: 1px solid darken($issue-border, 6%);
      border-radius: 999px;
      background-color: #fff;
      transition: border-color .15s ease, box-shadow .15s ease;

    &:focus {
        border-color: $issue-primary;
        box-shadow: 0 0 0 3px $issue-primary-soft;
        outline: none;
    }
  }
}

// Filters modal
.list #filters {
    .modal-content {
        border: none;
        border-radius: $issue-radius;
        box-shadow: $issue-shadow-hover;
    }
    .modal-header {
        border-bottom: 1px solid $issue-border;
        .modal-title {
            font-weight: 700;
            font-size: 16px;
        }
    }
    .modal-footer {
        border-top: 1px solid $issue-border;
    }
    .input-group-text {
        background-color: $issue-bg-subtle;
        border-color: $issue-border;
        color: $issue-text-muted;
        min-width: 130px;
    }
    .custom-select,
    .form-control {
        border-color: $issue-border;
        &:focus {
            border-color: $issue-primary;
            box-shadow: 0 0 0 3px $issue-primary-soft;
        }
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .row.list {
        padding-left: 10px;
    }
    .issues-wrapper > .col-lg-4 {
        padding-left: 6px;
    }
}

@media (max-width: 600px) {
    .row.list {
        padding: 14px 12px 20px;
    }
    .issue-container, .issues-wrapper {
        padding: 0;
    }
}
</style>
